import React, {useEffect} from "react";
import {Avatar, Box, Drawer, Typography, useMediaQuery, useTheme} from "@mui/material";
import logo from "../../assets/logo/3d-logo.png";
import { Link } from "react-router-dom";
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import { useLocation, useNavigate } from "react-router";
import { removeUser } from "../../store/auth";
import {useDispatch, useSelector} from "react-redux";
import { confirmation } from "../../services/utills";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import {CustomDrawer, drawerWidth} from "./adminSidebar";
import Pusher from "pusher-js";
import {getAllUserNotification} from "../../store/user/notification";
import { getAllClinics, getAllMessages } from "../../store/user/Chat-modue";
import PersonIcon from '@mui/icons-material/Person';
import MailIcon from '@mui/icons-material/Mail';
import LockIcon from '@mui/icons-material/Lock';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import NotificationsIcon from '@mui/icons-material/Notifications';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import WalletIcon from '@mui/icons-material/Wallet';
import HeadphonesIcon from '@mui/icons-material/Headphones';
import TodayIcon from '@mui/icons-material/Today';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import {scrollCSS} from "../../App";
import defaultPersonImg from "../../assets/images/default-person-img.png";

const listItemStyle = {
    borderRadius: "8px",
    mb: "8px",
    padding: '10px 20px',
    width: '100%',
    justifyContent: 'flex-start',
    transition: 'background-color 0.3s, color 0.3s',
    position: 'relative',
    overflow: 'hidden',
    "&:hover": {
        backgroundColor: "rgba(167,44,104,0.08)",
        color: "#1a1a2e",
        "& .MuiTypography-root": { color: '#1a1a2e' },
        "& .MuiListItemIcon-root, & .MuiListItemIcon-root *": { color: '#A72C68 !important' },
    },
    "&:hover::before": {
        content: '""',
        position: 'absolute',
        left: 0,
        top: '6px',
        bottom: '6px',
        width: '4px',
        borderRadius: '0 4px 4px 0',
        background: '#A72C68',
    },
};

const sideData = [
    { name: "MY BOOKINGS",    logo: <CalendarMonthIcon style={{ color: '#9CA3AF', fontSize: "28px" }} />, url: "/user/bookings" },
    { name: "TREATMENT PLANS",logo: <TodayIcon style={{ color: '#9CA3AF', fontSize: "28px" }} />,         url: "/user/plans/listing" },
    { name: "MILESTONES",     logo: <AssignmentIndIcon style={{ color: '#9CA3AF', fontSize: "28px" }} />, url: "/user/milestone" },
    { name: "MY WALLET",      logo: <WalletIcon style={{ color: '#9CA3AF', fontSize: "28px" }} />,        url: "/user/wallet" },
    { name: "INBOX",          count: "inbox", logo: <MailIcon style={{ color: '#9CA3AF', fontSize: "28px" }} />, url: "/user/inbox" },
    { name: "MY MEMBERSHIP",  logo: <AccountBalanceWalletIcon style={{ color: '#9CA3AF', fontSize: "28px" }} />, url: "/user/membership" },
    { name: "MY PROFILE",     logo: <PersonIcon style={{ color: '#9CA3AF', fontSize: "28px" }} />,        url: "/user/my-account" },
    { name: "PASSWORD",       logo: <LockIcon style={{ color: '#9CA3AF', fontSize: "28px" }} />,          url: "/user/password" },
    { name: "SPA LOCATION",   logo: <LocationOnIcon style={{ color: '#9CA3AF', fontSize: "28px" }} />,    url: "/user/default-spa-location" },
    { name: "ALERTS",         count: "notification", logo: <NotificationsIcon style={{ color: '#9CA3AF', fontSize: "28px" }} />, url: "/user/notification" },
    { name: "REFER & SHARE",  logo: <PeopleAltIcon style={{ color: '#9CA3AF', fontSize: "28px" }} />,     url: "/user/refer/share" },
    { name: "SUPPORT",        logo: <HeadphonesIcon style={{ color: '#9CA3AF', fontSize: "28px" }} />,    url: "/user/support" },
];

const UserSidebar = ({ sidebarOpen, mobileOpen, setMobileOpen }) => {
    const unreadCounter  = useSelector(state => state?.userNotificationStore?.unreadCounter);
    const unreadCounterr = useSelector(state => state?.UserChatStore?.unreadCounter);
    const authStore      = useSelector(state => state?.authStore);
    const { user }       = authStore;

    const location   = useLocation();
    const navigate   = useNavigate();
    const dispatch   = useDispatch();
    const theme      = useTheme();
    const isMdScreen = useMediaQuery(theme.breakpoints.down('lg'));
    const { pathname } = location;

    useEffect(() => {
        setMobileOpen(false);
    }, [pathname]);

    const handleLogout = async () => {
        if (await confirmation("Are you want to logout", "Yes, Logout!")) {
            localStorage.removeItem("token");
            dispatch(removeUser());
            document.cookie.split(";").forEach(cookie => {
                const name = cookie.split("=")[0];
                document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
            });
            navigate("/login");
            window.location.reload();
        }
    };

    const handleNavigate = (url) => {
        setMobileOpen(false);
        navigate(url);
    };

    useEffect(() => {
        const pusher  = new Pusher('5e9dcc6e9cd79dc83685', { cluster: 'mt1' });
        const channel = pusher.subscribe(`notifications.user.${user?.id}`);
        channel.bind('pusher:subscription_succeeded', () => {});
        channel.bind("App\\Events\\NotificationUserUnreadCountEvent", () => {
            dispatch(getAllUserNotification());
        });
        return () => { pusher.unsubscribe(`notifications.user.${user?.id}`); };
    }, [dispatch, user?.id]);

    useEffect(() => {
        const pusher      = new Pusher('5e9dcc6e9cd79dc83685', { cluster: 'mt1' });
        const chatChannel = pusher.subscribe(`customer.chat.unread.${user?.id}`);
        chatChannel.bind("App\\Events\\CustomerMessageUnreadCountEvent", () => {
            if (user) {
                dispatch(getAllMessages(user?.default_provider_id));
                dispatch(getAllClinics());
            }
        });
        return () => { pusher.unsubscribe(`customer.chat.unread.${user?.id}`); };
    }, [dispatch, user?.id, user?.default_provider_id]);

    useEffect(() => {
        dispatch(getAllUserNotification());
        dispatch(getAllMessages(user?.default_provider_id));
    }, [dispatch, user?.default_provider_id]);

    const showLabels = sidebarOpen || isMdScreen;

    const checkActive = (url) => pathname === url;

    const drawer = () => (
        <Box
            sx={{
                borderRight: "1px solid #F0CDDB",
                height: "100vh",
                padding: showLabels ? "16px 5px 16px 16px" : "6px",
                '@media (max-width:350px)': { padding: "16px 16px" },
                overflowY: "auto",
                ...scrollCSS,
                '&::-webkit-scrollbar':       { width: '8px' },
                '&::-webkit-scrollbar-track': { background: '#FAEFF5', borderRadius: '8px' },
                '&::-webkit-scrollbar-thumb': { background: '#A72C68', borderRadius: '8px', border: '2px solid #FAEFF5' },
                '&::-webkit-scrollbar-thumb:hover': { background: '#9CA3AF' },
                scrollbarColor: '#A72C68 #FAEFF5',
                scrollbarWidth: 'thin',
            }}
        >
            {/* Logo */}
            <Box sx={{ mt: "3px", mb: "3px" }}>
                {showLabels ? (
                    <Link to={"/"}>
                        <img src={logo} alt="3D Lifestyle" height="fit-content" width="100%" />
                    </Link>
                ) : null}
            </Box>

            {/* User profile pill */}
            {showLabels && (
                <Box
                    sx={{
                        my: 2,
                        p: 1.5,
                        borderRadius: "10px",
                        background: "linear-gradient(135deg, rgba(167,44,104,0.08) 0%, rgba(167,44,104,0.04) 100%)",
                        border: "1px solid #F0CDDB",
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5,
                    }}
                >
                    <Avatar
                        src={user?.profile_image || undefined}
                        sx={{
                            width: 38,
                            height: 38,
                            border: "2px solid #A72C68",
                            flexShrink: 0,
                            background: user?.profile_image ? undefined : "linear-gradient(135deg, #A72C68 0%, #921F58 100%)",
                            color: "#fff",
                            fontSize: "15px",
                            fontWeight: 700,
                        }}
                    >
                        {!user?.profile_image && (user?.name?.charAt(0)?.toUpperCase() || "U")}
                    </Avatar>
                    <Box sx={{ minWidth: 0 }}>
                        <Typography
                            sx={{
                                fontSize: "13px",
                                fontWeight: 700,
                                color: "#1a1a2e",
                                lineHeight: 1.2,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                fontFamily: "helvetica-lt-std-bold,sans-serif",
                            }}
                        >
                            {user?.name || "Guest"}
                        </Typography>
                        <Typography sx={{ fontSize: "11px", color: user?.is_membered === 1 ? "#16A34A" : "#9CA3AF", mt: 0.25, fontWeight: user?.is_membered === 1 ? 600 : 400, fontFamily: "helvetica-lt-std-roman,sans-serif" }}>
                            {user?.is_membered === 1 ? "✦ Member" : "Standard account"}
                        </Typography>
                    </Box>
                </Box>
            )}

            {/* Nav */}
            <Box>
                <List
                    sx={{
                        width: "100%",
                        ".MuiListItemIcon-root": { minWidth: "37px" },
                    }}
                    component="nav"
                >
                    {sideData.map((item, index) => {
                        const isActive   = checkActive(item.url);
                        const notifCount = item.count === "notification" ? unreadCounter : item.count === "inbox" ? unreadCounterr : 0;

                        return (
                            <ListItemButton
                                key={index}
                                onClick={() => handleNavigate(item.url)}
                                sx={{
                                    ...listItemStyle,
                                    backgroundColor: isActive ? "#A72C68" : "transparent",
                                    color: isActive ? "#fff" : "#1a1a2e",
                                    justifyContent: "space-between",
                                    "&:hover": {
                                        backgroundColor: isActive ? "#921F58" : "rgba(167,44,104,0.08)",
                                    },
                                    "&::before": isActive ? {
                                        content: '""',
                                        position: 'absolute',
                                        left: 0,
                                        top: '6px',
                                        bottom: '6px',
                                        width: '4px',
                                        borderRadius: '0 4px 4px 0',
                                        background: '#A72C68',
                                    } : {},
                                    "& .MuiTypography-root": { color: isActive ? '#fff !important' : '#1a1a2e !important' },
                                    "& .MuiListItemIcon-root, & .MuiListItemIcon-root *": {
                                        color: isActive ? '#fff !important' : '#1a1a2e !important',
                                    },
                                }}
                            >
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                    <ListItemIcon>{item.logo}</ListItemIcon>
                                    {showLabels && (
                                        <ListItemText
                                            primary={item.name}
                                            primaryTypographyProps={{
                                                sx: {
                                                    fontWeight: 700,
                                                    fontSize: '14px',
                                                    letterSpacing: '0.04em',
                                                    fontFamily: 'helvetica-lt-std-bold,sans-serif',
                                                },
                                            }}
                                        />
                                    )}
                                </Box>

                                {notifCount > 0 && (
                                    <Box
                                        sx={{
                                            background: "linear-gradient(135deg, #EF4444 0%, #DC2626 100%)",
                                            color: "#fff",
                                            fontSize: "11px",
                                            px: "7px",
                                            py: "2px",
                                            borderRadius: "20px",
                                            minWidth: "22px",
                                            textAlign: "center",
                                            fontWeight: 700,
                                            boxShadow: "0 2px 4px rgba(239,68,68,0.35)",
                                        }}
                                    >
                                        {notifCount}
                                    </Box>
                                )}
                            </ListItemButton>
                        );
                    })}

                    {/* Divider */}
                    <Box sx={{ height: "1px", background: "#F0CDDB", my: 1, mx: 0.5 }} />

                    {/* Logout */}
                    <ListItemButton
                        onClick={handleLogout}
                        sx={{
                            ...listItemStyle,
                            backgroundColor: "transparent",
                            color: "#1a1a2e",
                            "& .MuiTypography-root": { color: '#1a1a2e' },
                            "& .MuiListItemIcon-root, & .MuiListItemIcon-root *": { color: '#1a1a2e !important' },
                            "&:hover": {
                                backgroundColor: "rgba(220,38,38,0.07)",
                                "& .MuiTypography-root": { color: '#DC2626 !important' },
                                "& .MuiListItemIcon-root, & .MuiListItemIcon-root *": { color: '#DC2626 !important' },
                            },
                            "&:hover::before": { background: '#DC2626' },
                        }}
                    >
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                            <ListItemIcon>
                                <PowerSettingsNewIcon style={{ color: '#9CA3AF', fontSize: "28px" }} />
                            </ListItemIcon>
                            {showLabels && (
                                <ListItemText
                                    primary="LOGOUT"
                                    primaryTypographyProps={{
                                        sx: {
                                            fontWeight: 700,
                                            fontSize: '14px',
                                            letterSpacing: '0.04em',
                                            fontFamily: 'helvetica-lt-std-bold,sans-serif',
                                        },
                                    }}
                                />
                            )}
                        </Box>
                    </ListItemButton>
                </List>
            </Box>
        </Box>
    );

    return (
        <Box>
            <Drawer
                variant="temporary"
                open={mobileOpen}
                onClose={() => setMobileOpen(false)}
                sx={{
                    display: { xs: 'block', lg: 'none' },
                    '& .MuiDrawer-paper': {
                        boxSizing: 'border-box',
                        width: { xs: '70%', sm: drawerWidth },
                    },
                }}
            >
                {drawer()}
            </Drawer>
            <CustomDrawer
                variant="permanent"
                open={sidebarOpen}
                sx={{
                    display: { xs: 'none', lg: 'block' },
                }}
            >
                {drawer()}
            </CustomDrawer>
        </Box>
    );
};

export default UserSidebar;
